module.exports = __webpack_public_path__ + "img/37.93ff6fdf.jpg";